import React, { useState } from "react";
import { Link, useLocation, Outlet } from "react-router-dom";
import {
  ChevronDown,
  ChevronRight,
  X,
  ShoppingBag,
  ShoppingCart,
  Users,
  Home
} from "lucide-react";
import { FiGift, FiFileText, FiSettings, FiBarChart2, FiHelpCircle } from "react-icons/fi";

export default function DashboardWithNavbar() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState("");
  const location = useLocation();

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const toggleDropdown = (name) =>
    setOpenDropdown(openDropdown === name ? "" : name);

 const menu = [
 {
  title: "Dashboard",
  key: "dashboard",
  icon: <Home size={18} />,
  links: [
    { name: "Dashboard Home", href: "/dashboard" }
  ]
},
    {
      title: "Catalog",
      key: "catalog",
      icon: <ShoppingBag size={18} />,
      links: [
        { name: "Products", href: "/catalog/products" },
        { name: "Categories", href: "/catalog/categories" },
        { name: "Manufacturers", href: "/catalog/manufacturers" },
        { name: "Product Reviews", href: "/catalog/reviews" },
        { name: "Product Tags", href: "/catalog/tags" },
        { name: "Attributes", href: "/catalog/attributes" },
      ],
    },
    {
      title: "Sales",
      key: "sales",
      icon: <ShoppingCart size={18} />,
      links: [
        { name: "Orders", href: "/sales/orders" },
        { name: "Shipments", href: "/sales/shipments" },
        { name: "Return Requests", href: "/sales/returns" },
        { name: "Recurring Payments", href: "/sales/payments" },
      ],
    },
    {
      title: "Customers",
      key: "customers",
      icon: <Users size={18} />,
      links: [
        { name: "Customers List", href: "/customers/list" },
        { name: "Online Customers", href: "/customers/online" },
        { name: "Customer Roles", href: "/customers/roles" },
        { name: "Activity Logs", href: "/customers/logs" },
        { name: "Vendors", href: "/customers/vendors" },
      ],
    },
    {
      title: "Promotions",
      key: "promotions",
      icon: <FiGift />,
      links: [
        { name: "Discounts", href: "/promotions/discounts" },
        { name: "Affiliates", href: "/promotions/affiliates" },
        { name: "Newsletter Subscribers", href: "/promotions/newsletter" },
        { name: "Campaigns", href: "/promotions/campaigns" },
      ],
    },
    {
      title: "Content Management",
      key: "content",
      icon: <FiFileText />,
      links: [
        { name: "Topic (Pages)", href: "/content/pages" },
        { name: "Message Templates", href: "/content/message" },
        { name: "News Items", href: "/content/items" },
        { name: "News Comments", href: "/content/news" },
        { name: "Blog Posts", href: "/content/posts" },
        { name: "Blog Comments", href: "/content/comments" },
        { name: "Polls", href: "/content/polls" },
        { name: "Forums", href: "/content/forums" },
      ],
    },
    {
      title: "Configuration",
      key: "config",
      icon: <FiSettings />,
      links: [
        
        { name: "Email Accounts", href: "/configuration/email-accounts" },
        { name: "Stores", href: "/configuration/stores" },
        { name: "Countries", href: "/configuration/countries" },
        { name: "Languages", href: "/configuration/languages" },
        { name: "Currencies", href: "/configuration/currencies" },
        { name: "Payment Methods", href: "/configuration/payment-methods" },
        { name: "Payment Restrictions", href: "/configuration/payment-restrictions" },
        { name: "Tax Providers", href: "/configuration/tax-providers" },
        { name: "Tax Categories", href: "/configuration/tax-categories" },
      ],
    },
    {
      title: "Reports",
      key: "reports",
      icon: <FiBarChart2 />,
      links: [
        { name: "Power BI", href: "/reports/powerbi" },
        { name: "Sales Summary", href: "/reports/sales-summary" },
        { name: "Low Stock", href: "/reports/low-stock" },
        { name: "Bestsellers", href: "/reports/bestsellers" },
        { name: "Products Never Purchased", href: "/reports/products-never-purchased" },
        { name: "Country Sales", href: "/reports/country-sales" },
        { name: "Registered Customers", href: "/reports/registered-customers" },
        { name: "Customers by Order Total", href: "/reports/customers-by-order-total" },
        { name: "Customers by Number of Orders", href: "/reports/customers-by-number-of-orders" },
      ],
    },
    {
      title: "Help",
      key: "help",
      icon: <FiHelpCircle />,
      links: [
        { name: "Training", href: "/help/training" },
        { name: "Documentation", href: "/help/documentation" },
        { name: "Community Forums", href: "/help/community-forums" },
        { name: "Premium Support Services", href: "/help/premium-support" },
        { name: "Solution Partners", href: "/help/solution-partners" },
      ],
    },
  ];

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <aside
        className={`fixed z-40 inset-y-0 left-0 w-64 bg-white text-gray-900 border-r border-gray-200 transform ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0`}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
          <h1 className="text-2xl font-bold text-blue-600">RouteKart</h1>
          <button onClick={toggleSidebar} className="text-gray-700 lg:hidden">
            <X size={24} />
          </button>
        </div>

        <nav className="mt-4 space-y-1 overflow-y-auto h-[calc(100vh-56px)]">
        
          {menu.map((item) => (
            <div key={item.key}>
              <button
                onClick={() => toggleDropdown(item.key)}
                className="w-full flex justify-between items-center px-6 py-3 text-gray-700 hover:bg-gray-100 rounded-md transition"
              >
                <div className="flex items-center gap-2">
                  {item.icon}
                  <span>{item.title}</span>
                </div>
                {openDropdown === item.key ? (
                  <ChevronDown size={18} />
                ) : (
                  <ChevronRight size={18} />
                )}
              </button>

              {openDropdown === item.key && (
                <div className="pl-10 bg-gray-50 border-l border-gray-200 transition-all duration-300 ease-in-out">
                  {item.links.map((sub, index) => (
                    <Link
                      key={index}
                      to={sub.href}
                      className={`block py-2 text-sm rounded-md transition-all ${
                        location.pathname === sub.href
                          ? "text-blue-600 font-semibold pl-2"
                          : "text-gray-600 hover:text-blue-600 hover:pl-2"
                      }`}
                    >
                      • {sub.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>
      </aside>

      {/* Main Content */}
      <div
        className={`flex-1 flex flex-col h-screen transition-all duration-300 ${
          sidebarOpen ? "lg:ml-64" : "lg:ml-0"
        }`}
      >
        {/* Mobile Topbar */}
        <div className="bg-white shadow-sm p-4 flex items-center justify-between lg:hidden">
          <h2 className="text-lg font-semibold text-gray-700">Dashboard</h2>
          <button onClick={toggleSidebar}>
            <X size={22} />
          </button>
        </div>

        {/* Outlet */}
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
